import { ApiConfig } from './api';
import { fetchWrapper, objectToSearchParams } from './utils/http-utils';
import { OrgPublishResource, ResourceError, ResourceRef } from '../types/org-publish';
import { PublishedOrg } from '../types/organization';

export const getPublished =
  (config: ApiConfig) =>
  (
    destinationOrg: number
  ): Promise<{
    published: OrgPublishResource[];
    warnings: ResourceError[];
  }> =>
    fetchWrapper<{
      published: OrgPublishResource[];
      warnings: ResourceError[];
    }>(
      `${config.endpoint}org_publish`,
      {
        method: 'POST',
        body: JSON.stringify({
          destination_org: destinationOrg,
          action: 'get',
        }),
      },
      config
    );

export const sync =
  (config: ApiConfig) =>
  (
    destinationOrg: number,
    resources: ResourceRef[],
    action: 'publish' | 'update' | 'revoke' | 'restate'
  ): Promise<{
    published: OrgPublishResource[];
    warnings: ResourceError[];
  }> =>
    fetchWrapper<{
      published: OrgPublishResource[];
      warnings: ResourceError[];
    }>(
      `${config.endpoint}org_publish`,
      {
        method: 'POST',
        body: JSON.stringify({
          resources,
          destination_org: destinationOrg,
          action,
        }),
      },
      config
    );

export const getPublishedOrgs = (config: ApiConfig) => (): Promise<{ organizations: PublishedOrg[] }> =>
  fetchWrapper<{ organizations: PublishedOrg[] }>(
    `${config.endpoint}org_publish/organizations`,
    {
      method: 'GET',
    },
    config
  );

export const getPrefix = (config: ApiConfig) => (): Promise<{ prefix: string }> =>
  fetchWrapper<{ prefix: string }>(
    `${config.endpoint}org_publish/prefix`,
    {
      method: 'GET',
    },
    config
  );

export const updatePrefix =
  (config: ApiConfig) =>
  (newPrefix?: string): Promise<{ prefix: string }> => {
    let url = `${config.endpoint}org_publish/prefix`;
    if (newPrefix) {
      const searchParams = objectToSearchParams({ new_prefix: newPrefix });
      url += `?${searchParams}`;
    }

    return fetchWrapper<{ prefix: string }>(
      url,
      {
        method: 'PUT',
      },
      config
    );
  };
